<h1 matDialogTitle>{{ data.title }}</h1>

<div>
  <mat-dialog-content>
    @if (htmlContent) {
      <span>
        <div [innerHtml]="htmlContent"></div>
      </span>
    } @else {
      <p>
        {{ data.content }} <strong>{{ data.name }}</strong>
      </p>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button id="confirm-button-cancel" mat-raised-button (click)="cancelAction(true)" mat-dialog-close cdkFocusInitial>
      {{ data.cancelLabel ? data.confirmLabel : data.title }}
    </button>
    @if (!data?.hideConfirmButton) {
      <button id="confirm-button-ok" mat-raised-button (click)="confirmAction(true)" color="{{data.buttonType}}">
        {{ data.confirmLabel ? data.confirmLabel : data.title }}
      </button>
    }
  </mat-dialog-actions>
</div>